import { render, staticRenderFns } from "./b15.vue?vue&type=template&id=3412e2ac&scoped=true"
import script from "./b15.vue?vue&type=script&lang=js"
export * from "./b15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412e2ac",
  null
  
)

export default component.exports